<section id="sidebar">
    <div [class.mostrar]="mostrar" class="contenedor__lateral">
        <svg-icon (click)="cerrar()" class="svg-cerrar" src="assets/svgs/cerrar.svg"></svg-icon>
        <ng-content></ng-content>
    </div>
</section>